<template>
	<div>
		<div class="mask" v-if="status">
			<img :src="img" alt="" />
		</div>
	</div>
</template>

<script>
	import img from '@/assets/img/loading.png'
	export default {
		data() {
			return {
				status: false,
				img,
			}
		},
		methods: {
			show() {
				this.status = true
			},
			hide() {
				this.status = false
			},
		},
	}
</script>

<style lang="scss" scoped>
	.mask {
		position: fixed;
		z-index: 1000;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background-color: rgba($color: #000000, $alpha: 0.7);
		display: flex;
		justify-content: center;
		align-items: center;
		img {
			width: 40px;
			height: 40px;
			animation: loading 1.5s linear infinite;
		}
	}
	@keyframes loading {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
